/* eslint-disable */
export default {
  to: 'Naar:',
  transferTo: 'Doorschakelen naar',
  blindTransfer: 'Doorschakelen',
  warmTransfer: 'Eerst vragen',
  enterNameOrNumber: 'Nummer invoeren',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
